var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-caption font-weight-light"},[_vm._v(" frontend: "+_vm._s(_vm.frontendVersion)+" | backend: "+_vm._s(_vm.backendVersion)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }